module.exports = __webpack_public_path__ + "static/media/KFOmCnqEu92Fr1Mu7WxKKTU1Kvnz.40e72ad2.woff2";